<h1>
  This is a demo where <a target="_blank" href="https://github.com/KostyaTretyak/less-offset-comments">less-offset-comments</a> utility is used
</h1>

<p>
  The demo was <a href="https://github.com/KostyaTretyak/less-offset-comments-demo">written on Angular 9</a>.
</p>

<hr>
<ng-container style="margin-top: 50px;">
  <button (click)="onSubmit()">Sumbit root comment</button>
  as user:
  <select [formControl]="select">
    <option *ngFor="let item of [1, 2, 3, 4]" [ngValue]="item">{{ item }}</option>
  </select>
</ng-container>

<div class="comment-container">
  <cst-thread [comments]="comments"></cst-thread>
</div>
